import * as tslib_1 from "tslib";
import { ReportsService } from '../../reports.service';
import { DeadlinesApi } from './api/deadlines-api.service';
import { DeadlinesMapperService } from './deadlines.mapper.service';
import * as i0 from "@angular/core";
import * as i1 from "./api/deadlines-api.service";
import * as i2 from "./deadlines.mapper.service";
import * as i3 from "../../reports.service";
var DeadlinesResolverService = /** @class */ (function () {
    function DeadlinesResolverService(api, mapper, reportsService) {
        this.api = api;
        this.mapper = mapper;
        this.reportsService = reportsService;
    }
    DeadlinesResolverService.prototype.getAverageDeadlinesAndTimeline = function (_a) {
        var footerWhere = _a.footerWhere, currentWhere = _a.currentWhere, responsePeriod = _a.responsePeriod, solutionPeriod = _a.solutionPeriod;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var toPromise, averageDeadlines, responseTimeline, solutionTimeline;
            return tslib_1.__generator(this, function (_b) {
                toPromise = [];
                averageDeadlines = this.getAverageDeadlines({
                    currentWhere: currentWhere,
                    footerWhere: footerWhere
                });
                responseTimeline = this.getTimeline({
                    where: currentWhere,
                    timelineOption: responsePeriod,
                });
                toPromise.push(averageDeadlines, responseTimeline);
                if (responsePeriod !== solutionPeriod) {
                    solutionTimeline = this.getTimeline({
                        where: currentWhere,
                        timelineOption: solutionPeriod
                    });
                    toPromise.push(solutionTimeline);
                }
                return [2 /*return*/, Promise.all(toPromise)];
            });
        });
    };
    DeadlinesResolverService.prototype.getAverageDeadlines = function (_a) {
        var currentWhere = _a.currentWhere, footerWhere = _a.footerWhere;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _b, footerPeriod, currentPeriod;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.reportsService.getAverageDeadlines(footerWhere).toPromise(),
                            this.reportsService.getAverageDeadlines(currentWhere).toPromise()
                        ])];
                    case 1:
                        _b = tslib_1.__read.apply(void 0, [_c.sent(), 2]), footerPeriod = _b[0], currentPeriod = _b[1];
                        return [2 /*return*/, {
                                footerPeriod: footerPeriod,
                                currentPeriod: currentPeriod
                            }];
                }
            });
        });
    };
    DeadlinesResolverService.prototype.getTimeline = function (_a) {
        var where = _a.where, timelineOption = _a.timelineOption;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var whereInput;
            return tslib_1.__generator(this, function (_b) {
                whereInput = this.mapper.toTimelineWhere({ where: where, timelineOption: timelineOption });
                return [2 /*return*/, this.api.getResponseDeadlinesTimeline(whereInput).toPromise()];
            });
        });
    };
    DeadlinesResolverService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeadlinesResolverService_Factory() { return new DeadlinesResolverService(i0.ɵɵinject(i1.DeadlinesApi), i0.ɵɵinject(i2.DeadlinesMapperService), i0.ɵɵinject(i3.ReportsService)); }, token: DeadlinesResolverService, providedIn: "root" });
    return DeadlinesResolverService;
}());
export { DeadlinesResolverService };
